<template>
  <div v-if="caseDetail.status != 'created'">
    <info-container title="Tickets">
      <div class="tw-flex tw-flex-col">
        <div v-if="loadingTickets">Laden...</div>
        <div v-if="tickets.length > 0">
          <small-ticket-list-item
            v-for="ticket in tickets"
            :key="ticket.id"
            :ticket="ticket"
            @edit="selectedTicket = ticket"
            :editable="true"
            :show-case="false"
          />
        </div>
        <div>
          <button
            :disabled="!canCreateTicket"
            class="tw-bg-gray-500 tw-rounded tw-p-1 tw-text-white tw-mt-3 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
            @click="showCreateTicketModal = true"
          >
            Maak onderhoudsticket aan
          </button>
        </div>
      </div>
    </info-container>
    <case-new-ticket
      v-if="showCreateTicketModal"
      :caseDetail="caseDetail"
      @close="showCreateTicketModal = false"
    />
    <case-selected-ticket
      v-if="selectedTicket"
      :caseDetail="caseDetail"
      :selectedTicket="selectedTicket"
      @close="selectedTicket = null"
    />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import fetchData from '@/util/fetch'
import InfoContainer from '@/components/shared/InfoContainer.vue'
import SmallTicketListItem from '@/components/shared/SmallTicketListItem.vue'
import CaseNewTicket from './CaseNewTicket.vue'
import CaseSelectedTicket from './CaseSelectedTicket.vue'

const props = defineProps({
  caseDetail: {
    type: Object,
    required: true,
  },
})

const id = computed(() => props.caseDetail.id)
const selectedTicket = ref(null)

const showCreateTicketModal = ref(false)

const { data: ticketsQuery, isLoading: loadingTickets } = useQuery({
  queryKey: computed(() => ['tickets', 'case', id.value]),
  keepPreviousData: true,
  queryFn: async () => {
    try {
      const result = await fetchData(`/tickets/api/v1/tickets?view=list&case_id=${id.value}`)
      return result.data
    } catch (error) {
      console.error('Error fetching tickets:', error)
      throw error
    }
  },
})

const tickets = computed(() => ticketsQuery.value || [])

const canCreateTicket = computed(() => ['open', 'created'].includes(props.caseDetail.status))
</script>
